import useMediaQuery from '@mui/material/useMediaQuery'
import theme from 'commons/styles/theme'

function useMobile() {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return isMobile
}

export default useMobile
